/* eslint no-class-assign:off */
/* eslint no-console:off */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getLang, getRelatedTypes, getIsRelatedFetching } from '../reducers';
import Loading from '../components/Loading';
import RelatedBlock from '../containers/RelatedBlock';
import SecondaryHeader from '../components/SecondaryHeader';

class Related extends Component {
  componentDidMount() {
    this.fetchData();
  }
  componentDidUpdate(prevProps) {
    const { contentId } = this.props;
    if (contentId !== prevProps.contentId) {
      this.fetchData();
    }
  }
  fetchData() {
    const { contentId, fetchRelated } = this.props;
    fetchRelated(contentId);
  }
  render() {
    const { lang, isFetching, types, color, contentId } = this.props;
    return (
      <aside className="related-col">
        <SecondaryHeader lang={lang} title="related" />
        <div className="fold__col__body">
          {
            isFetching && !types.length ?
              <Loading /> :
              types.map(item => (
                <RelatedBlock lang={lang} type={item} contentId={contentId} color={color} key={`${contentId}-${item}`} />
              ))
          }
        </div>
      </aside>
    );
  }
}

Related.propTypes = {
  lang: PropTypes.string.isRequired,
  fetchRelated: PropTypes.func.isRequired,
  contentId: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
};

Related.defaultProps = {
  workshop: {},
  contentId: undefined,
};

const mapStateToProps = (state, { contentId }) => ({
  lang: getLang(state),
  types: getRelatedTypes(state, contentId),
  isFetching: getIsRelatedFetching(state),
});

Related = connect(
  mapStateToProps,
  actions,
)(Related);

export default Related;



// WEBPACK FOOTER //
// ./js/containers/Related.js